import { FileFilterPageInfo, IntegrationSchedule } from "../../types/types"


export const INTEGRATION_ACTION_TYPES = {
    SET_INTEGRATION_SCHEDULE: "SET_INTEGRATION_SCHEDULE",
    SET_PROFILE_NAME: "SET_PROFILE_NAME",
    SET_ENTITY_NAME: "SET_ENTITY_NAME",
    SET_DELIMITER: "SET_DELIMITER",
    SET_ENCODING: "SET_ENCODING",
    SET_STARTS_WITH: "SET_STARTS_WITH",
    SET_PASSKEY: "SET_PASSKEY",
    SET_TRANSFORMER_ID: "SET_TRANSFORMER_ID",
    SET_MAPPER: "SET_MAPPER",
    SET_OUT_PROFILE_NAME: "SET_OUT_PROFILE_NAME",
    SET_ENTITY_FILE_MAPPING: "SET_ENTITY_FILE_MAPPING",
    SET_EXTRA_PARAMS: "SET_EXTRA_PARAMS",
    SET_GENERIC: "SET_GENERIC" ,
    SET_LOB: "SET_LOB",
    RESET:"RESET",
    SET_MAPPER_NAME:"SET_MAPPER_NAME",
    SET_FILE_FILTER_PAGE_INFO:"SET_FILE_FILTER_PAGE_INFO",
    SET_HEADERS:"SET_HEADERS"
}

function setIntegrationSchedule(IntegrationSchedule: IntegrationSchedule) {
    return { type: INTEGRATION_ACTION_TYPES.SET_INTEGRATION_SCHEDULE, payload: IntegrationSchedule }
}

function setProfileName(ProfileName: string) {
    return { type: INTEGRATION_ACTION_TYPES.SET_PROFILE_NAME, payload: ProfileName }
}

function setFileFilterPageInfo(param: FileFilterPageInfo) {
    return { type: INTEGRATION_ACTION_TYPES.SET_FILE_FILTER_PAGE_INFO, payload: param }
}

function setTransformerId(TransformerId: string) {
    return { type: INTEGRATION_ACTION_TYPES.SET_TRANSFORMER_ID, payload: TransformerId }
}

function setMapper(Mapper: { mapper: string, mapperName: string }) {
    return { type: INTEGRATION_ACTION_TYPES.SET_MAPPER, payload: Mapper }
}

function setOutProfileName(OutProfileName: string) {
    return { type: INTEGRATION_ACTION_TYPES.SET_OUT_PROFILE_NAME, payload: OutProfileName }
}

function setEntityFileMapping(EntityFileMapping: string) {
    return { type: INTEGRATION_ACTION_TYPES.SET_ENTITY_FILE_MAPPING, payload: EntityFileMapping }
}

function setExtraParams(ExtraParams: any) {
    return { type: INTEGRATION_ACTION_TYPES.SET_EXTRA_PARAMS, payload: ExtraParams }
}

function setLob(Lob:string) {
    return { type: INTEGRATION_ACTION_TYPES.SET_LOB, payload: Lob}
}
function setGeneric(param:{key:string,val:any}) {
    return { type: INTEGRATION_ACTION_TYPES.SET_GENERIC, payload:{[param.key]:param.val}}
}
function reset() {
    return { type: INTEGRATION_ACTION_TYPES.RESET, payload:{}}
}

function setHeaders(headers:string){
    return { type: INTEGRATION_ACTION_TYPES.SET_HEADERS, payload:headers}
}

export const IntegrationActions = {
    setIntegrationSchedule,
    setProfileName,
    setFileFilterPageInfo,
    setTransformerId,
    setMapper,
    setOutProfileName,
    setEntityFileMapping,
    setExtraParams,
    setLob,
    setGeneric,
    reset,
    setHeaders
}
